import {TrustLevelPriority, TrustLevels} from "./types";

export const  isAllowedTrustLevel = (requiredInput: string, currentInput: string) => {
  const required = requiredInput.toUpperCase();
  const current = currentInput.toUpperCase();

  const keyCurrent = Object.keys(TrustLevels).find(key => {
    return TrustLevels[key] === current;
  });
  const keyRequired = Object.keys(TrustLevels).find(key => {
    return TrustLevels[key] === required;
  });
  return TrustLevelPriority[keyRequired] <= TrustLevelPriority[keyCurrent];
}